import {Button, useAnalytics} from 'bigdatr-style';
import React from 'react';
import api from '~/api';

export default function ConnectedTV() {
    const submitTrackingForm = api.useSubmitHubspotForm();
    const analytics = useAnalytics();

    return (
        <>
            <p>
                You can now have visibility into Connected TV advertising right alongside the
                channels you already monitor. Track competitor campaigns and spend across Netflix,
                Disney+, Binge, Stan and more.
            </p>

            <p>
                See what competitor brands are running, where they&apos;re spending, and how CTV
                fits into the bigger picture.
            </p>

            <p>
                Connect with us to bring CTV into your Advertising Creative library and Media Value
                tool.
            </p>

            <p>
                <Button
                    onClick={() => {
                        analytics.chat();
                        submitTrackingForm.mutate({formId: '0ad20f3d-672e-4b9f-92f2-169eb52e03a5'});
                    }}
                >
                    Talk to us
                </Button>
            </p>
        </>
    );
}
